export default __webpack_public_path__ + "static/en-4d9d990626a3df96a26531a13fe513dc.png";